import matchesResponsiveToken from './matches-responsive-token';

const removeResponsiveClasses = ({ currentClass = '', className, breakpoint }) => {
  const filtered = currentClass
    .split(' ')
    .filter((cls) => cls && !matchesResponsiveToken(cls, className, breakpoint));

  return filtered.join(' ');
};

export default removeResponsiveClasses;
